export default "__VITE_ASSET__Bpu3E9fQ__"